"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _alloyReactIcon = require("@adsk/alloy-react-icon");

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _mediaDetailContext = require("../media-detail-context");

var _qa = _interopRequireDefault(require("../../../util/qa"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NavButtonContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 120px;
`;
const StyledChevronLeftIcon = (0, _styledComponents.default)(_alloyReactIcon.ChevronLeftIcon)`
  cursor: pointer;
  &:hover {
    color: ${_alloyReactTheme.default.colors.adskBlue500};
  }
`;
const StyledChevronRightIcon = (0, _styledComponents.default)(_alloyReactIcon.ChevronRightIcon)`
  cursor: pointer;
  &:hover {
    color: ${_alloyReactTheme.default.colors.adskBlue500};
  }
`;
const PhotoNav = _styledComponents.default.div`
  font-size: ${_alloyReactTheme.default.typography.bodyMedium};
`;

const Nav = () => {
  const {
    state: {
      photoNav
    },
    mediaHandlers: {
      pageForward,
      pageBack
    }
  } = (0, _mediaDetailContext.useMedia)();
  return /*#__PURE__*/_react.default.createElement(NavButtonContainer, {
    "data-qa": _qa.default.mediaDetailToolbar
  }, /*#__PURE__*/_react.default.createElement(StyledChevronLeftIcon, {
    "data-qa": _qa.default.mediaDetailPageBackButton,
    size: 20,
    color: _alloyReactTheme.default.colors.white,
    onClick: pageBack
  }), /*#__PURE__*/_react.default.createElement(PhotoNav, null, photoNav[0], " of ", photoNav[1]), /*#__PURE__*/_react.default.createElement(StyledChevronRightIcon, {
    "data-qa": _qa.default.mediaDetailPageForwardButton,
    size: 20,
    color: _alloyReactTheme.default.colors.white,
    onClick: pageForward
  }));
};

var _default = Nav;
exports.default = _default;